import styled from 'styled-components';

export const FavoriteProductWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 50px auto 0;
`;
